import BusinessNoInfoCap from "./BusinessNoInfoCap";

export default BusinessNoInfoCap;